// AI Generated file
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'inverseColorCode',
    standalone: false,
})
export class InverseColorCodePipe implements PipeTransform {
    transform (hex: string): string {
        return this.getTextColor(hex);
    }

    private getTextColor (hexColor: string): string {
        if (typeof hexColor !== 'string') {
            return '#000000';
        }

        const background = this.getLuminance(hexColor);
        const foreground = this.getLuminance('#000000');
        const ratio = (background + 0.05) / (foreground + 0.05); // ratio between foreground and background luminance

        if (ratio >= 4.5) {
            return '#000000'; // ratio needs to be at least 4.5 according to WCAG 2.0 level AA
        }
        return '#FFFFFF';
    }

    private getRGB (c: string): number {
        const colorDecimal = parseInt(c, 16) / 255;
        if (colorDecimal <= 0.03928) {
            return colorDecimal / 12.92;
        } else {
            return Math.pow(((colorDecimal + 0.055) / 1.055), 2.4);
        }
    }

    private getLuminance (hexColor: string): number {
        return (0.2126 * this.getRGB(hexColor.substr(1, 2)) + 0.7152 * this.getRGB(hexColor.substr(3, 2)) + 0.0722 * this.getRGB(hexColor.substr(-2)));
    }
}
